import { decodeToken } from "../functions/decode-token";

export class TokenPayload {
    CustomerId: string;
    email: string;
    exp: number;
    iat: number;
    name: string;
    nameid: string;
    nbf: string;
    role: string;
    roles: string;
}

export function jwtPayload(): TokenPayload | null {
    const token = localStorage.getItem('tristateToken');
    if (!token) {
        return null;
    }
    const payload: TokenPayload = decodeToken(token);
    return payload;
}